import React from 'react';
import {connect} from "react-redux";

export default connect((state, props) => {
  return {}
})(({width, height}) => {
    let logo = "";
    if (window.location.hostname === "theme2.epaylocal" || window.location.hostname === "payments.epco.us" || window.location.hostname === "payments-qa.epco.us") logo = "/theme2_logo.jpg";
    if (window.location.hostname === "theme3.epaylocal" || window.location.hostname === "payments.republicelevator.com" || window.location.hostname === "payments-qa.republicelevator.com") logo = "/theme3_logo.png";
    if (window.location.hostname === "theme4.epaylocal" || window.location.hostname === "payments.suburbanelevator.com" || window.location.hostname === "payments-qa.suburbanelevator.com") logo = "/theme4_logo.png";
    if (window.location.hostname === "theme5.epaylocal" || window.location.hostname === "payments.eltec.cc" || window.location.hostname === "payments-qa.eltec.cc") logo = "/elteclogo.png";

    if (logo === "") {
      return null;
    } else {
      return <img src={logo} alt={"Company Logo"} width={width} height={height}/>
    }
  }
);